// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import InsuranceCoverageForms from './InsuranceCoverageForms';
import { formValueSelector, FieldArray } from 'utils/reduxFormWrapper';
import { RadioGroupField } from 'shared/containers/portal_layout/HForm';
import { connect } from 'react-redux';

const Form = ({ payMethod, prefix, form }) => (
  <div className="clearfix">
    <RadioGroupField
      label="Patient Insurance"
      name={`${prefix}.payMethod`}
      options={[
        { value: 'insurance', label: 'Patient has insurance' },
        { value: 'self-pay', label: 'Patient plans to self-pay' },
      ]}
    />
    {payMethod === 'insurance' ? (
      <FieldArray
        name={`${prefix}.insuranceCoverages`}
        component={InsuranceCoverageForms}
        form={form}
      />
    ) : null}
  </div>
);

Form.propTypes = {
  payMethod: PropTypes.string,
  prefix: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const payMethod = formValueSelector(ownProps.form)(state, `${ownProps.prefix}.payMethod`);
  return {
    payMethod,
  };
};

export default connect(mapStateToProps)(Form);
